const updatesData = [
  { date: '2026-07-28', title: '「剑尊归来」第203话更新：剑域降临！', type: '更新', genre: '玄幻' },
  { date: '2026-07-28', title: '「女神降临」第156话：最终告白', type: '更新', genre: '恋爱' },
  { date: '2026-07-28', title: '「狐妖小红娘」第389话更新', type: '更新', genre: '恋爱' },
  { date: '2026-07-27', title: '「我独自升级」第179话：最终之战开启', type: '更新', genre: '热血' },
  { date: '2026-07-27', title: '「反派千金」第88话：王宫舞会', type: '更新', genre: '恋爱' },
  { date: '2026-07-27', title: '「斗破苍穹」第512话更新上线', type: '更新', genre: '玄幻' },
  { date: '2026-07-26', title: '酷看漫画App新版本 v3.2.0 发布', type: '公告', genre: '平台' },
  { date: '2026-07-26', title: '本周编辑精选：韩漫恋爱特辑', type: '专题', genre: '推荐' },
  { date: '2026-07-25', title: '「全职高手」第421话：荣耀之巅', type: '更新', genre: '热血' },
];

export default function Updates() {
  return (
    <section id="updates" className="py-12 md:py-16 bg-background-100">
      <div className="max-w-[980px] mx-auto px-4 md:px-6">
        <div className="text-center mb-8 md:mb-10">
          <h2 className="text-xl md:text-2xl font-black text-foreground-950 mb-2">更新动态</h2>
          <p className="text-sm text-foreground-500">最新漫画更新和平台动态，一网打尽</p>
        </div>

        <div className="relative">
          <div className="absolute left-[15px] md:left-[19px] top-2 bottom-2 w-px bg-background-300"></div>

          <div className="space-y-4">
            {updatesData.map((item, i) => (
              <div key={i} className="relative flex items-start gap-4 md:gap-5 pl-10 md:pl-12">
                <div className={`absolute left-0 w-[9px] h-[9px] md:w-[11px] md:h-[11px] rounded-full border-2 border-background-50 ${
                  item.type === '公告' ? 'bg-accent-500' :
                  item.type === '专题' ? 'bg-primary-500' :
                  'bg-secondary-500'
                }`}></div>

                <div className="flex-1 min-w-0">
                  <div className="flex flex-col sm:flex-row sm:items-center gap-1 sm:gap-3 mb-1">
                    <span className="text-xs text-foreground-400 whitespace-nowrap">{item.date}</span>
                    <span className={`hidden sm:inline text-[10px] px-1.5 py-0.5 rounded-full font-medium whitespace-nowrap ${
                      item.type === '公告' ? 'bg-accent-100 text-accent-700' :
                      item.type === '专题' ? 'bg-primary-100 text-primary-700' :
                      'bg-secondary-100 text-secondary-700'
                    }`}>
                      {item.type}
                    </span>
                  </div>
                  <a
                    href="#updates"
                    onClick={(e) => e.preventDefault()}
                    className="text-sm font-medium text-foreground-800 hover:text-primary-500 transition-colors no-underline"
                  >
                    {item.title}
                  </a>
                  <span className="ml-2 text-[10px] px-1.5 py-0.5 rounded-full bg-background-200 text-foreground-500 font-medium whitespace-nowrap">
                    {item.genre}
                  </span>
                </div>
              </div>
            ))}
          </div>
        </div>

        <div className="text-center mt-8">
          <a
            href="#updates"
            onClick={(e) => e.preventDefault()}
            className="inline-flex items-center gap-1 text-sm font-medium text-primary-500 hover:text-primary-600 transition-colors whitespace-nowrap"
          >
            查看更多动态 <i className="ri-arrow-right-line"></i>
          </a>
        </div>
      </div>
    </section>
  );
}